import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { RuntimeConfigService } from "./runtime-config.service";

/**
 * Matches only when preview mode is active (assets/app-config.json: { "previewMode": true }).
 * Returning false makes the router fall through to the next matching route (e.g. the wildcard
 * not-found route) instead of activating this one.
 */
export const previewModeGuard: CanMatchFn = () =>
  inject(RuntimeConfigService).previewMode;
